import React from "react";
import { AuthProvider } from "../contexts/AuthContext";

export default function ContextProviders({
  children,
}: React.PropsWithChildren<{}>) {
  return <AuthProvider>{children}</AuthProvider>;
}

